export enum StatisticTypeEnum {
  Count = 'COUNT',
  Sum = 'SUM',
  Avg = 'AVG',
  Min = 'MIN',
  Max = 'MAX',
  Stddev = 'STDDEV',
  Var = 'VAR',
}
